const OPEN_HOUR = 6;
const RESULTS_HOUR = 13;

function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

export function getDayVibeDateKey(date = new Date()): string {
  return [
    date.getFullYear(),
    pad2(date.getMonth() + 1),
    pad2(date.getDate()),
  ].join('-');
}

export function getNextLocalMidnight(date = new Date()): Date {
  const next = new Date(date);
  next.setDate(next.getDate() + 1);
  next.setHours(0, 0, 0, 0);
  return next;
}

export function getDayVibeOpenTime(date = new Date()): Date {
  const opensAt = new Date(date);
  opensAt.setHours(OPEN_HOUR, 0, 0, 0);
  return opensAt;
}

export function isDayVibesOpen(date = new Date()): boolean {
  return date.getHours() >= OPEN_HOUR;
}

export function getDayVibeResultsTime(date = new Date()): Date {
  const resultsAt = new Date(date);
  resultsAt.setHours(RESULTS_HOUR, 0, 0, 0);
  return resultsAt;
}

export function isDayVibeResultsOpen(date = new Date()): boolean {
  return date.getHours() >= RESULTS_HOUR;
}

export function getNextDayVibeBoundary(date = new Date()): Date {
  if (!isDayVibesOpen(date)) {
    return getDayVibeOpenTime(date);
  }
  if (!isDayVibeResultsOpen(date)) {
    return getDayVibeResultsTime(date);
  }
  return getNextLocalMidnight(date);
}
